
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/deal/[year]/[slug]",
      function () {
        return require("private-next-pages/deal/[year]/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/deal/[year]/[slug]"])
      });
    }
  